import {useEffect, useLayoutEffect, useRef, useState} from "react";
import {Image} from "react-bootstrap";
import {useTranslation} from "react-i18next";

const IconBox = ({iconName, specialClass, clickFunction, size, svg = false}) => {
  const ref = useRef(null)
  const {i18n: {dir, language}} = useTranslation()
  const imageRef = useRef(null)

  useLayoutEffect(() => {
    if (iconName === 'backIcon') {
      const div = ref.current
      if (dir(language) === 'ltr') {
        div.style.transform = 'rotate(180deg)'
      } else {
        div.style.removeProperty('transform')
      }
    }
  }, [dir, iconName, language])

  useEffect(() => {
    if (!svg && iconName && imageRef?.current) {
      import(`./../../asset/icons/${iconName}.svg`).then(res => {
        if (res?.default) {
          imageRef.current.src = res.default
        }
      }).catch(err => {
        console.log('err', err, iconName)
      })
    }
  }, [iconName, svg])

  return (
    <div
      ref={ref}
      className={`icon_component_box ${specialClass} ${size}`}
      onClick={clickFunction}
    >
      {
        svg ?
          <Icon name={iconName}/>
          :
          // <Image src={window.location.origin + `/dashboard/asset/icons/${iconName}.svg`} className="image"/>
          <Image src="" ref={imageRef} className="image"/>
      }
    </div>
  );
};

const Icon = ({name, ...rest}) => {
  const ImportedIconRef = useRef(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const importIcon = async () => {
      try {
        ImportedIconRef.current = (await import(`!!@svgr/webpack?-svgo,+titleProp,+ref!./../../asset/icons/${name}.svg`)).default;

      } catch (err) {
        throw err;
      } finally {
        setLoading(false);
      }
    };
    importIcon();
  }, [name]);

  if (!loading && ImportedIconRef.current) {
    const {current: ImportedIcon} = ImportedIconRef;
    return <ImportedIcon {...rest} />;
  }

  return null;
};
export default IconBox;
